// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import PlusCircle20 from './PlusCircle20';
import PlusCircle20Filled from './PlusCircle20Filled';
import PlusCircle24 from './PlusCircle24';
import PlusCircle24Filled from './PlusCircle24Filled';
import PlusCircle40 from './PlusCircle40';
import PlusCircle40Filled from './PlusCircle40Filled';

type PlusCircleProps = {
    variation: '20' | '20Filled' | '24' | '24Filled' | '40' | '40Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    PlusCircle20,
    PlusCircle20Filled,
    PlusCircle24,
    PlusCircle24Filled,
    PlusCircle40,
    PlusCircle40Filled,
};

const PlusCircle: FC<PlusCircleProps> = ({ variation, ...props }) => {
    const variationKey = `PlusCircle${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"PlusCircle" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default PlusCircle;
